import { render, staticRenderFns } from "./ProductLowStocks.vue?vue&type=template&id=0458aa98&scoped=true&"
import script from "./ProductLowStocks.vue?vue&type=script&lang=js&"
export * from "./ProductLowStocks.vue?vue&type=script&lang=js&"
import style0 from "./ProductLowStocks.vue?vue&type=style&index=0&id=0458aa98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0458aa98",
  null
  
)

export default component.exports